<script>
    import AdminBar from "../../components/AdminBar.svelte";
    import Foot from "../../components/Foot.svelte";
    import Button from "../../components/Button.svelte";
    import {backofficeServiceHost, userRef} from "../../stores/magic-wallet-store";

    let operatorPlayerId = "";
    let operatorId = "mrq";
    let country = "UK";
    let currency = "GBP";
    let jurisdiction = "UKGC";

    let goosicornUserRef = ""
    let isNewPlayer = ""
    let playerSessionId = ""

    const registerPlayer = async () => {
        const data = {
            country,
            currency,
            jurisdiction,
            operatorId,
            operatorPlayerId
        }

        const response = await (await fetch(`${backofficeServiceHost}/users/register`, {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(data)
        })).json()

        goosicornUserRef = response.userRef
        isNewPlayer = response.isNewPlayer
        playerSessionId = response.playerSessionId

        userRef.set(goosicornUserRef)

        console.log(response)
    }
</script>

<AdminBar/>

<section>
    <h2>User Registration</h2>
    <span><label>Operator PlayerId</label> <input class="userRef-input" type="text" bind:value={operatorPlayerId}></span>
    <div class="data-section">
        <label>Operator ID </label> <input class="user-input" type="text" readonly bind:value={operatorId}>
        <label>Country </label> <input class="user-input" type="text" readonly bind:value={country}>
        <label>Currency </label> <input class="user-input" type="text" readonly bind:value={currency}>
        <label>Jurisdiction </label> <input class="user-input" type="text" readonly bind:value={jurisdiction}>
    </div>
    <div class="button-holder">
        <Button text="Register/Retrieve" onClickFunction={registerPlayer}/>
    </div>
</section>
<section>
    <div class="result-section">
        <label>Goosicorn UserRef</label><input class="userRef-input" type="text" readonly bind:value={goosicornUserRef}>
        <label>Is this a new player?</label><input class="user-input" type="text" readonly bind:value={isNewPlayer}>
        <label>New PlayerSession Identifier</label><input class="userRef-input" type="text" readonly bind:value={playerSessionId}>
    </div>
</section>

<Foot/>

<style>
    span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;
    }

    section {
        margin: 24px auto;
        padding: 24px;
        width: 100%;
        max-width: 600px;
        border: 1px solid black;
    }

    .data-section {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 20px;
        align-items: center;
    }

    .result-section {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        align-items: center;
    }

    input {

    }

    .userRef-input {
        width: 40ch;
    }

    .user-input {
        width: 10ch;
    }
</style>
